export default __webpack_public_path__ + "static/media/hospitality.eba8d0b9.jpeg";